/** Tipos comunes de los servicios (inventario §3 y D25). */

/** Importe en céntimos + moneda ISO 4217 (openapi: Money). */
export interface Money {
  amount: number
  currency: string
}

/** Lo mínimo que un servicio necesita de la reserva para llamar al PMS. */
export interface StayRef {
  /** reserveId */
  id: string
  guestCode: string
  /** Host del servidor de la reserva (sin ruta) */
  serverPath: string
}

export const money = (amount: number, currency = 'EUR'): Money => ({ amount, currency })

/** `"450.00"` / `"450,00"` / `"1.250,50"` → céntimos. `null` si no es un número. */
export function parseMoney(value: string | number | null | undefined, currency = 'EUR'): Money | null {
  if (value === null || value === undefined) return null
  if (typeof value === 'number') return Number.isFinite(value) ? money(Math.round(value * 100), currency) : null
  const trimmed = value.trim()
  if (trimmed === '') return null
  // Si hay coma y punto, el último separador es el decimal; si solo hay coma, es decimal.
  const lastComma = trimmed.lastIndexOf(',')
  const lastDot = trimmed.lastIndexOf('.')
  let normalized: string
  if (lastComma > lastDot) normalized = trimmed.replace(/\./g, '').replace(',', '.')
  else normalized = trimmed.replace(/,/g, '')
  const n = Number(normalized)
  return Number.isFinite(n) ? money(Math.round(n * 100), currency) : null
}

/** Moneda del PMS (`currencyCode` puede venir como símbolo). */
export function normalizeCurrency(code: string | null | undefined): string {
  if (!code || code.trim() === '' || code === '€') return 'EUR'
  if (code === '$') return 'USD'
  if (code === '£') return 'GBP'
  return code
}
